import {
  SET_INSPECTION_FILTERS
} from '../actions/inspections'

export default function (state = {}, action) {
  switch (action.type) {
    case SET_INSPECTION_FILTERS: {
      const { locationId, filter } = action.payload
      return {
        ...state,
        [locationId]: {
          ...state[locationId],
          ...filter
        }
      }
    }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/inspection-filters.js